import { BitrixVue } from 'ui.vue';

BitrixVue.cloneComponent('Step10', 'Steps', {
	data() {
		return {
			step: null,
			selectedMolding: 0,
			showStep: false,
		};
	},
	props: ['openingDoorSystem', 'doorCover'],
	created() {
		// this.getDataStep();
		// this.step = this.openingDoorSystem.moldings;
	},
	mounted() {
		if (this.openingDoorSystem !== undefined && this.openingDoorSystem.moldings !== undefined) {
			this.showStep = true;
			const molding = this.openingDoorSystem.moldings[this.selectedMolding];
			const nacenkaType = this.doorCover.price_nacenka_type;
			const nacenkaPrice = this.doorCover.price_nacenka_pogonag;
			let price = 0;

			if (nacenkaType) {
				price = (molding.price + molding.price * (nacenkaPrice / 100)) * molding.kf;
			} else {
				price = (molding.price + nacenkaPrice) * molding.kf;
			}
			this.setPropPosition({
				molding: {
					...this.openingDoorSystem.moldings[this.selectedMolding],
					price: price,
				},
			});
		} else {
			this.showStep = false;
			this.setPropPosition({
				molding: 1,
			});
		}
	},
	methods: {
		getDataStep: function () {
			let context = this;
			let store = { ...this.$store.state.position };
			delete store.renderImage;
			let req = BX.ajax.runComponentAction('mworks:configurator', 'getDataStep10', {
				mode: 'class',
				method: 'post',
				data: {
					position: store,
				},
			});

			req.catch(function (response) {
			});

			req.then((response) => {
				if (response.status == 'success') {
					context.step = response.data.result;
				}
			});
		},
		isDataStep: function () {
			return this.step;
		},
		setMolding(index) {
			this.selectedMolding = index;
		},
	},
	watch: {
		selectedMolding: function (val) {
			if (val !== null) {
				const molding = this.openingDoorSystem.moldings[val];
				const nacenkaType = this.doorCover.price_nacenka_type;
				const nacenkaPrice = this.doorCover.price_nacenka_pogonag;
				let price = 0;
				if (nacenkaType) {
					price = (molding.price + molding.price * (nacenkaPrice / 100)) * molding.kf;
				} else {
					price = (molding.price + nacenkaPrice) * molding.kf;
				}

				this.setPropPosition({
					molding: {
						...molding,
						price: price,
					},
				});
			} else {
				this.setPropPosition({ molding: null });
			}
		},
		'openingDoorSystem.title'(val, oldValue) {
			if (val === undefined) {
				this.selectedMolding = null;
				return;
			}
			if (val !== oldValue) {
				this.selectedMolding = null;
			}
		},
	},
	template: `
	<div class="config-block" v-if="showStep">
		<div class="config-block__inner">
			<div class="config-block__wrap">
				<div class="config-block__wrap-title">Тип погонажа</div>
				<Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="3">
					<div class="swiper-slide" v-for="(slide, index) of openingDoorSystem.moldings">
						<SimpleItem :image="slide.image" :title="slide.title"
						:price="doorCover.price_nacenka_type ? (slide.price + slide.price * (doorCover.price_nacenka_pogonag / 100)) * slide.kf : (slide.price + doorCover.price_nacenka_pogonag) * slide.kf"
						:priceType="2" :key="index"
							:class="{active: selectedMolding === index}" v-on:setActive="setMolding(index)" />
					</div>
				</Swiper>
			</div>
			<div class="config-block__wrap mt-48 w-100p sm:w-50p" v-if="selectedMolding !== null && openingDoorSystem.moldings[selectedMolding]?.korob">
				<div class="config-block__wrap-title">Дверной короб</div>
				<InputDisabled name="door_frame" :value="openingDoorSystem.moldings[selectedMolding].korob + ' мм'">
			</div>
		</div>
	</div>
`,
});
